import { render, staticRenderFns } from "./addOzoneAlarmDialog.vue?vue&type=template&id=50764c61&scoped=true"
import script from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
export * from "./addOzoneAlarmDialog.vue?vue&type=script&lang=js"
import style0 from "./addOzoneAlarmDialog.vue?vue&type=style&index=0&id=50764c61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50764c61",
  null
  
)

export default component.exports